module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-379.0bd7a17.woff2";